export default __webpack_public_path__ + "static/media/close.1d4ee480.svg";